export enum EstadoServAbastecedora {
    EnServicio,
    FueraServicio,
    LimpiezaInspeccion,
    TallerMecanico,
    Desvinculado,
    FueraDePlanta,
    FueraDeEspecificacion,
    EnAnalisis
}